import axios from 'axios';

export default {
    loadCaseStudies(options, productCategory = null, market=null, page = 1) {
        options.page = page;

        var params = {
            action: "get_case_studies",
            options: options,
            product_category: productCategory,
            market: market
        };
        return axios.get(wp_globals.ajax_url, {params});
    }
}